import React, { useEffect, useState } from 'react'

import useDispatch from 'hooks/useDispatch'
import { updateFilters } from '../../../../../actions/searchActions'

import Inputs from './Inputs'

type Props = {
  open: boolean
  filters: GQL_SearchFilters
}

const SpecificDates = ({ open, filters }: Props) => {
  const dispatch = useDispatch()
  const [startDate, setStartDate] = useState(filters?.startDate || null)
  const [endDate, setEndDate] = useState(filters?.endDate || null)

  useEffect(() => {
    setStartDate(filters.startDate || null)
  }, [filters?.startDate])

  useEffect(() => {
    setEndDate(filters.endDate || null)
  }, [filters?.endDate])

  const handleDatesChange = (
    nextDates: Pick<GQL_SearchFilters, 'startDate' | 'endDate'>
  ) => {
    setStartDate(nextDates?.startDate)
    setEndDate(nextDates?.endDate)

    if (nextDates?.startDate != null && nextDates?.endDate != null) {
      dispatch(
        updateFilters({
          startDate: nextDates?.startDate,
          endDate: nextDates?.endDate,
        })
      )
    }
  }

  return (
    <Inputs
      valueKey="dates"
      startDate={startDate}
      endDate={endDate}
      onChange={handleDatesChange}
      show={open}
    />
  )
}

export default SpecificDates
